module.exports = __webpack_public_path__ + "static/img/quickly-send.07281857.png";